// extracted by mini-css-extract-plugin
export default {"splitedString":"ClickableQuestion_splitedString__CbADs"};